import { EventEmitter, Output } from '@angular/core';

/**
 * Form Component の親クラス
 */
export abstract class FormBaseComponent {


    @Output()
    loading = new EventEmitter();

    /**
     * アラート表示部分
     */
    messages: Array<{type: string, message: string}> = [];
    alertDismissOnTimeout: any;

    protected alert(type: string,  message: string, timeout?: number) {
        
        this.alertDismissOnTimeout = timeout;

        this.messages.push({
            type: type,
            message: message
        });
    }
}


// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/components/form/form-base.component.ts